<template>
  <div id="app">
    <HeaderMain />
    <component :is="layout">
      <router-view />
    </component>
    <footer class="bg-secondary text-center">
      <div class="footer-title">
        LiveVOTE
      </div>
      <div class="footer-links">
        <b-link to="/terms">Kasutustingimused</b-link>
        <b-link to="/contact">Kontakt</b-link>
      </div>
    </footer>
  </div>
</template>

<script>
import HeaderMain from "@/components/HeaderMain";

const default_layout = "default";

export default {
  name: "App",
  components: { HeaderMain },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout';
    }
  }
};
</script>